module.exports = __webpack_public_path__ + "img/en-j.3be716f5.png";